import { apiClient as api } from "./client";

export interface ApiKeyResponse {
  id: string;
  name: string;
  keyPrefix: string;
  orgId: string;
  createdByUserId: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  isRevoked: boolean;
  createdAt: string;
}

export interface ApiKeyCreatedResponse {
  id: string;
  name: string;
  keyPrefix: string;
  key: string;
  createdAt: string;
}

export const apiKeysApi = {
  getAll: async (): Promise<ApiKeyResponse[]> => {
    return api.get<ApiKeyResponse[]>("/api/api-keys");
  },

  create: async (name: string): Promise<ApiKeyCreatedResponse> => {
    return api.post<ApiKeyCreatedResponse>("/api/api-keys", { name });
  },

  revoke: async (id: string): Promise<void> => {
    return api.delete(`/api/api-keys/${id}`);
  },
};
